var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaginationFirstActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#338dc7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-919 -1273)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    transform: "translate(935 1273) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.958.435h0L10,4H8.042L5,1.306,1.959,4H0L4,.435H4L4.167.311a1.272,1.272,0,0,1,1.666,0Z",
    transform: "translate(923 1286) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.958.435h0L10,4H8.042L5,1.306,1.959,4H0L4,.435H4L4.167.311a1.272,1.272,0,0,1,1.666,0Z",
    transform: "translate(927 1286) rotate(-90)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaginationFirstActive);
export default __webpack_public_path__ + "static/media/icon-pagination-first-active.f0f30a25.svg";
export { ForwardRef as ReactComponent };